import { render, staticRenderFns } from "./applicationList.vue?vue&type=template&id=2f083650&scoped=true&"
import script from "./applicationList.vue?vue&type=script&lang=js&"
export * from "./applicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f083650",
  null
  
)

export default component.exports